import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import {
	fluidPadding,
	fluidValues,
	fontStyle,
} from '@/css/resources/mixins.css';
import { breakpoints } from '@/css/resources/variables.css';
import { colors } from '@/css/variables.css';
import { grid } from '@/css/resources/placeholders.css';

const getStyles = (nbCards) =>
	css(
		fluidPadding({
			top: [70, 105],
			bottom: [100, 150],
		}),
		{
			background: colors.brand.orange,
			// Remove negative margin top caused by default variant section following each others
			marginTop: '0 !important',

			'.supt-section__inner': cssObj(grid, {
				'.supt-section__headline': cssObj(
					fluidValues('top', 135, 240, true),
					{
						gridColumn: '1 / span 12',

						[`@media (min-width: ${breakpoints.tablet})`]: {
							gridColumn: '1 / span 10',
						},
						[`@media (min-width: ${breakpoints.laptop})`]: {
							position: 'sticky',
							alignSelf: 'baseline',
							zIndex: 0,
							paddingBottom: 200,
						},
						[`@media (min-width: ${breakpoints.bigLaptop})`]: {
							gridColumn: '1 / span 8',
						},

						'& > *:first-child': {
							marginTop: '0px !important',
						},

						'.supt-section__title': cssObj(
							fontStyle({
								fontFamily: 'Knockout, sans-serif',
								fontWeight: 500,
								fontSize: [66, 110],
								lineHeight: [54, 94],
								letterSpacing: [0, 0],
								textTransform: 'uppercase',
								textAlign: 'left',
								color: '#000000',
								margin: {
									bottom: '0.25em',
								},
							})
						),
					}
				),

				'.supt-section__content': cssObj({
					gridColumn: '1 / span 12',

					position: 'relative',
					zIndex: 1,
					[`@media (min-width: ${breakpoints.laptop})`]: {
						marginTop: -200,
					},

					'& > *:last-child': {
						marginBottom: '0px !important',
					},

					'.supt-cardShow': {
						[`@media (min-width: ${breakpoints.laptop})`]: {
							...Array.from({ length: nbCards }).reduce<
								Record<string, { gridColumnStart: number }>
							>((acc, _, index) => {
								const minColumnStart = index % 2 === 0 ? 1 : 7;
								let maxColumnStart =
									index % 2 === 0 ? 6 : 13 - 4; // 13 is on right and 4 is the minimum number of column for the card's width

								const gridColumnStart = Math.round(
									Math.random() *
										(maxColumnStart - minColumnStart) +
										minColumnStart
								);
								const marginTop = Math.round(
									Math.random() * 150
								);
								return {
									...acc,
									[`&:nth-child(${index + 1})`]: {
										gridColumnStart,
										marginTop,
									},
								};
							}, {}),
						},
					},
				}),
			}),

			// Remove negative margin top caused by default variant section following each others
			'& + .supt-section--default': {
				marginTop: '0 !important',
			},
		}
	);

export { getStyles };
